import {
    TableRow,
    TableBody,
    TableCell,
    TableContainer,
    Paper,
    Table,
    TableHead,
    IconButton,
    Box,
} from "@mui/material";
import { fDateTime } from "src/utils/formatTime";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

export default function CompetitionsTable({ competitions, onEdit, onDelete }) {
    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="competitions table">
                <TableHead>
                    <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>External ID</TableCell>
                        <TableCell>Sport</TableCell>
                        <TableCell>Created At</TableCell>
                        <TableCell>Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {competitions?.map((competition, index) => (
                        <TableRow
                            key={competition.competitionId || index}
                            sx={{
                                "&:last-child td, &:last-child th": { border: 0 },
                            }}
                        >
                            <TableCell component="th" scope="row">
                                {competition.competitionId}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                <strong>{competition.name}</strong>
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {competition.externalId}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {competition.sport}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {fDateTime(new Date(competition.createdAt))}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    {onEdit && (
                                        <IconButton
                                            size="small"
                                            color="primary"
                                            onClick={() => onEdit(competition)}
                                            title="Edit Competition"
                                        >
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                    )}
                                    {onDelete && (
                                        <IconButton
                                            size="small"
                                            color="error"
                                            onClick={() => onDelete(competition)}
                                            title="Delete Competition"
                                        >
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    )}
                                </Box>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
